import { motion } from "framer-motion";
import { Check } from "lucide-react";

export default function ThankYou({ name, onExit }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="w-full max-w-3xl mx-auto"
      data-testid="thank-you-view"
    >
      {/* Confirmation */}
      <div className="text-center">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.15, type: "spring", stiffness: 200, damping: 15 }}
          className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-[#6d28d9]"
        >
          <Check className="h-10 w-10 text-white" strokeWidth={3} />
        </motion.div>

        <h2 className="font-montserrat font-bold tracking-tight text-4xl sm:text-5xl text-white leading-tight">
          Grazie{name ? `, ${name.split(" ")[0]}` : ""}!
        </h2>
        <p className="mt-5 text-lg text-zinc-400 leading-relaxed max-w-xl mx-auto">
          Abbiamo ricevuto la tua richiesta. Un nostro consulente ti contatterà
          <span className="text-white font-semibold"> entro 24 ore</span> per illustrarti
          il percorso più adatto a triplicare il tuo fatturato.
        </p>
      </div>

      {/* Punchline */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.7 }}
        className="mt-16 text-center font-montserrat font-bold text-2xl sm:text-3xl text-white leading-tight"
        data-testid="thankyou-punchline"
      >
        Noi: un'azienda al fianco delle aziende.
      </motion.p>

      <div className="mt-14 text-center">
        <motion.button
          onClick={onExit}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.97 }}
          data-testid="thankyou-home-btn"
          className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-[#8b5cf6] px-8 py-3 text-sm font-semibold text-white transition-colors"
        >
          Ricomincia il questionario
        </motion.button>
      </div>
    </motion.div>
  );
}
